class Organization {
    id: number;
    name: string;

    constructor(data = null) {
        this.id = data?.id ?? 0;
        this.name = data?.name ?? "";
    }
}